import { render, staticRenderFns } from "./ModalAuthenticator.vue?vue&type=template&id=05fa4053&scoped=true&"
import script from "./ModalAuthenticator.vue?vue&type=script&lang=js&"
export * from "./ModalAuthenticator.vue?vue&type=script&lang=js&"
import style0 from "./ModalAuthenticator.vue?vue&type=style&index=0&id=05fa4053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa4053",
  null
  
)

export default component.exports